// global Config

import {mapValues} from 'lodash';

const configBase = {
    baseUrl: Config.base.twisterUrl,
    contentType: 'application/json',
    crossDomain: false,
    method: 'GET',
    responseType: 'json',
    timeout: 60000,
};

const servicesFormConfig = {
    async: {
        formName: 'massActionResults',
        path: 'mediaitems/states',
    },
    bulkMapShows: {
        method: 'POST',
        path: '/mediaitems/mappings/bulk',
        timeout: 300000,
        updateServiceDataKeys: ['mediaItemsDetail', 'unmappedMediaItems'],
    },
    bulkMapSpecials: {
        method: 'POST',
        path: '/mediaitems/mappings/bulk',
        timeout: 300000,
        updateServiceDataKeys: ['mediaItemsDetail', 'unmappedMediaItems'],
    },
    changePassword: {
        method: 'PUT',
        path: 'users/updatePassword',
    },
    createDisplayPath: {
        method: 'POST',
        path: 'displaypaths',
        providerFormFields: [{fieldName: 'network.name', valueKey: 'network.name'}],
        providerFormName: 'selectNetworkForDisplayPaths',
        updateServiceDataKeys: ['displayPaths'],
    },
    createDisplayPathModifier: {
        method: 'POST',
        path: 'displaypathmodifiers',
        providerFormFields: [{fieldName: 'network.name', valueKey: 'network.name'}],
        providerFormName: 'selectNetworkForDisplayPathModifiers',
        updateServiceDataKeys: ['displayPathModifiers'],
    },
    createExternalNetwork: {
        method: 'POST',
        path: 'networks/externalnetworks/mappings',
        providerFormFields: [{fieldName: 'networkId', valueKey: 'networkId'}],
        providerFormName: 'createExternalNetwork',
        timeout: 300000,
    },
    createMediaItemOffering: {
        method: 'POST',
        providerServiceDataKey: 'mediaItemDetail',
        path: 'offerings',
        responseType: 'text',
        updateServiceDataKeys: ['mediaItemDetail', 'mediaItems'],
    },
    createNetwork: {
        method: 'POST',
        path: 'networks',
        updateServiceDataKeys: ['networks'],
    },
    createProvider: {
        method: 'POST',
        path: 'providers',
        updateServiceDataKeys: ['providers'],
    },
    createRole: {
        method: 'POST',
        path: 'roles',
        updateServiceDataKeys: ['roles'],
    },
    createRule: {
        method: 'POST',
        path: 'rules',
        timeout: 120000,
        updateServiceDataKeys: ['rules'],
    },
    createShell: {
        method: 'POST',
        path: 'createShell',
    },
    createUser: {
        method: 'POST',
        path: 'users',
        updateServiceDataKeys: ['users'],
    },
    deleteDisplayPath: {
        method: 'DELETE',
        path: 'displaypaths',
        resetForms: ['editDisplayPath'],
        updateServiceDataKeys: ['displayPaths'],
    },
    deleteDisplayPathModifier: {
        method: 'DELETE',
        path: 'displaypathmodifiers',
        timeout: 120000,
        updateServiceDataKeys: ['displayPathModifiers'],
    },
    deleteOffering: {
        method: 'DELETE',
        path: 'offerings',
        updateServiceDataKeys: ['mediaItemDetail'],
    },
    deleteRole: {
        method: 'DELETE',
        path: 'roles',
        updateServiceDataKeys: ['roles'],
    },
    deleteRule: {
        method: 'DELETE',
        path: 'rules',
        timeout: 120000,
        updateServiceDataKeys: ['rules'],
    },
    deleteShell: {
        method: 'DELETE',
        path: 'amsprograms',
        updateServiceDataKeys: ['moviesAndPrograms', 'moviesAndProgramsDetail'],
    },
    displayPathModifiers: {
        providerServiceDataKey: 'displayPathModifierDetail',
        path: 'displaypathmodifiers',
        method: 'PUT',
        updateServiceDataKeys: ['displayPathModifiers'],
    },
    editDisplayPath: {
        method: 'PUT',
        path: 'displaypaths',
        providerServiceDataKey: 'displayPathDetail',
        updateServiceDataKeys: ['displayPaths'],
    },
    editDisplayPathModifier: {
        method: 'PUT',
        path: 'displaypathmodifiers',
        providerServiceDataKey: 'displayPathModifierDetail',
        updateServiceDataKeys: ['displayPathModifiers'],
    },
    editMediaItemOffering: {
        method: 'PUT',
        path: 'offerings',
        providerServiceDataKey: 'mediaItemDetail',
        responseType: 'text',
        updateServiceDataKeys: ['mediaItemDetail', 'mediaItems'],
    },
    editNetwork: {
        method: 'PUT',
        path: 'networks',
        providerServiceDataKey: 'networkDetail',
        updateServiceDataKeys: ['networks', 'networkDetail'],
    },
    editNetworkImage: {
        method: 'PUT',
        path: 'networks',
        providerServiceDataKey: 'networkDetail',
        timeout: 120000,
        updateServiceDataKeys: ['networks', 'networkDetail'],
    },
    editProvider: {
        method: 'PUT',
        path: 'providers',
        providerServiceDataKey: 'providerDetail',
        updateServiceDataKeys: ['providers', 'providerDetail'],
    },
    editRole: {
        method: 'PUT',
        path: 'roles',
        providerServiceDataKey: 'roleDetail',
        updateServiceDataKeys: ['roles', 'roleDetail'],
    },
    editRule: {
        method: 'PUT',
        path: 'rules',
        providerServiceDataKey: 'rulesDetail',
        timeout: 120000,
        updateServiceDataKeys: ['rules', 'rulesDetail'],
    },
    editShell: {
        method: 'PUT',
        path: 'amsprograms',
        providerServiceDataKey: 'moviesAndProgramsDetail',
        updateServiceDataKeys: ['moviesAndPrograms', 'moviesAndProgramsDetail'],
    },
    editUser: {
        method: 'PUT',
        path: 'users',
        providerServiceDataKey: 'userDetail',
        updateServiceDataKeys: ['users', 'userDetail'],
    },
    editUserPreferences: {
        method: 'PUT',
        path: 'users/preferences',
        providerServiceDataKey: 'userDetail',
        updateServiceDataKeys: ['users', 'userDetail'],
    },
    editVfb: {
        method: 'POST',
        path: 'amsprograms/{echostarId}/vfb',
        providerServiceDataKey: 'moviesAndProgramsDetail',
        updateServiceDataKeys: ['moviesAndPrograms', 'moviesAndProgramsDetail'],
    },
    flagMetadata: {
        method: 'POST',
        path: 'flaggedmetadata',
        timeout: 300000,
    },
    flaggedMetadataComments: {
        method: 'PUT',
        path: 'flaggedmetadata/issues',
        updateServiceDataKeys: ['flaggedMetadataDetail', 'flaggedMetadata'],
    },
    flaggedMetadataStatus: {
        method: 'PUT',
        path: 'flaggedmetadata/status',
        payloadType: 'params',
        updateServiceDataKeys: ['flaggedMetadata', 'flaggedMetadataDetail'],
    },
    flaggedMetadataUpdate: {
        method: 'PUT',
        path: 'flaggedmetadata',
        timeout: 300000,
    },
    forgotPassword: {
        method: 'POST',
        path: 'forgotPassword',
        payloadType: 'params',
    },
    generateMarker: {
        method: 'POST',
        path: 'marker/kafka',
        payloadType: 'params',
    },
    globalBingeConfig: {
        method: 'POST',
        path: 'bingewatchingconfig',
        providerServiceDataKey: 'networkDetail',
    },
    mapExternalNetwork: {
        method: 'PUT',
        path: 'networks/externalnetworks/mappings',
        timeout: 300000,
    },
    mapMediaItem: {
        method: 'POST',
        path: 'mediaitems/mappings',
        providerServiceDataKey: 'mediaItemDetail',
        timeout: 300000,
        updateServiceDataKeys: ['mediaItemsDetail'],
    },
    mediaItemReenrich: {
        method: 'PUT',
        path: 'mediaitems/states',
        timeout: 300000,
        updateServiceDataKeys: ['mediaItemDetail', 'mediaItems', 'violations', 'violationDetail', 'violationsRelated'],
    },
    mediaItemRepublish: {
        method: 'PUT',
        path: 'mediaitems/states',
        timeout: 300000,
        updateServiceDataKeys: ['mediaItemDetail', 'mediaItems', 'violations', 'violationDetail', 'violationsRelated'],
    },
    mediaItemsReenrich: {
        method: 'PUT',
        path: 'mediaitems/states',
        timeout: 300000,
        updateServiceDataKeys: ['mediaItemDetail', 'mediaItems'],
    },
    mediaItemsRepublish: {
        method: 'PUT',
        path: 'mediaitems/states',
        timeout: 300000,
        updateServiceDataKeys: ['mediaItemDetail', 'mediaItems'],
    },
    mediaItemsSunset: {
        method: 'PUT',
        path: 'mediaitems/offerings/enddates',
        timeout: 300000,
        updateServiceDataKeys: ['mediaItemDetail', 'mediaItems'],
    },
    networkBingeConfig: {
        method: 'POST',
        path: 'bingewatchingconfig',
        providerServiceDataKey: 'networkDetail',
    },
    resetPassword: {
        method: 'POST',
        path: 'resetPassword',
        payloadType: 'params',
    },
};

export default mapValues(servicesFormConfig, (config) => ({...configBase, ...config}));
